import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { PageHero } from "@/components/layout/PageHero";
import { HealthGauge, SubsystemList } from "@/components/health/HealthGauge";
import { JournalCard, RobotsCard } from "@/components/health/RobotsCard";
import { InstancesCard } from "@/components/health/InstancesCard";
import { PlaybookCard, TrainingCard } from "@/components/health/PlaybookCard";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

export default function AdminHealth() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [train, setTrain] = useState({ results: [] });
  const load = useCallback(() => api.get("/admin/selfheal").then(({ data }) => setD(data)).catch(() => {}), []);
  const loadTrain = useCallback(() => api.get("/admin/selfheal/training").then(({ data }) => setTrain(data)).catch(() => {}), []);
  useEffect(() => {
    load();
    loadTrain();
    const id = setInterval(load, 3000);
    return () => clearInterval(id);
  }, [load, loadTrain]);
  useEffect(() => {
    if (!d?.training?.running) return undefined;
    const id = setInterval(loadTrain, 3000);
    return () => clearInterval(id);
  }, [d?.training?.running, loadTrain]);
  return (
    <div data-testid="admin-health-page">
      <PageHero eyebrow={t("admin.eyebrow")} title={t("heal.title")}>
        <p className="mt-4 max-w-2xl text-sm text-neutral-400">{t("heal.subtitle")}</p>
      </PageHero>
      {!d ? (
        <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-[var(--gold)]" /></div>
      ) : (
        <div className="mx-auto grid max-w-7xl gap-6 px-4 pb-16 sm:px-8 lg:grid-cols-2">
          <HealthGauge d={d} />
          <SubsystemList subs={d.subsystems} />
          <RobotsCard robots={d.robots} workers={d.workers} />
          <InstancesCard />
          <JournalCard entries={d.journal} />
          <div className="min-w-0 lg:col-span-2"><TrainingCard training={{ ...d.training, ...train }} results={train.results || []} onStarted={loadTrain} /></div>
          <div className="min-w-0 lg:col-span-2"><PlaybookCard items={d.playbook} seed={d.seed} /></div>
        </div>
      )}
    </div>
  );
}
